import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { CampaignList_Top_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useCampaignTopQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(CampaignList_Top_Query, { variables: { hotelID } });

	return {
		data,
	};
};
